import React from "react";
import Download from "./Download";
import Upload from "./Upload";
import HistoryLogElement from "./HistoryLogElement";
import { renderGroupComponent } from "../../util/FormUtils";
import xplanLabels from "../../util/XplanLabels";

const newPlan = window.location.pathname === "/xplans/new";

const DownloadUploadFields = ({ category, data, handleFileChange, xplans, allowedRoles, tag, required }) => {
    return (
        <div className="planField">
            {renderGroupComponent(tag)}
            <div id={category} style={{ display: "flex", flexDirection: "column" }}>
                <Upload
                    category={category}
                    version={data[`${category}Version`]}
                    labels={xplanLabels}
                    handleFileChange={handleFileChange}
                    allowedRoles={allowedRoles}
                    required={required}
                />
                <Download fileId={data[`${category}`]} />
            </div>
            {!newPlan && <HistoryLogElement xplans={xplans} label={`${category}Version`} />}
        </div>
    );
};

export default DownloadUploadFields;
